export default (num, max) =>
	(Math.sqrt((max * max * Math.PI * (num / max)) / Math.PI) / max) * 100;



// WEBPACK FOOTER //
// ./utils/calcAreaPercentage.js